/**
 * Mekko API Client
 * Replaces supabaseClient.js. Talks to the Worker API.
 */

const API_BASE = import.meta.env?.VITE_API_URL || '';

async function apiFetch(path, options = {}) {
  const url = `${API_BASE}${path}`;
  const res = await fetch(url, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export const api = {
  // Auth
  register: (email, password) => apiFetch('/api/auth/register', { method: 'POST', body: JSON.stringify({ email, password }) }),
  login: (email, password) => apiFetch('/api/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  logout: () => apiFetch('/api/auth/logout', { method: 'POST' }),
  me: () => apiFetch('/api/auth/me'),
  changePassword: (currentPassword, newPassword) =>
    apiFetch('/api/auth/password', { method: 'PUT', body: JSON.stringify({ currentPassword, newPassword }) }),
  deleteAccount: () => apiFetch('/api/account', { method: 'DELETE' }),

  // Jobs
  getJobs: (params = {}) => {
    const qs = new URLSearchParams(params);
    return apiFetch(`/api/jobs?${qs}`);
  },

  // Filters
  getFilters: () => apiFetch('/api/filters'),
  createFilter: (filter) => apiFetch('/api/filters', { method: 'POST', body: JSON.stringify(filter) }),
  updateFilter: (id, filter) => apiFetch(`/api/filters/${id}`, { method: 'PUT', body: JSON.stringify(filter) }),
  deleteFilter: (id) => apiFetch(`/api/filters/${id}`, { method: 'DELETE' }),

  // Matches
  getMatches: (params = {}) => {
    const qs = new URLSearchParams(params);
    return apiFetch(`/api/matches?${qs}`);
  },

  // Notifications
  getNotificationSettings: () => apiFetch('/api/notifications/settings'),
  updateNotificationSettings: (integrationId, settings) =>
    apiFetch('/api/notifications/settings', { method: 'PUT', body: JSON.stringify({ integration_id: integrationId, settings }) }),
  sendWhatsAppTest: (payload = {}) =>
    apiFetch('/api/notifications/whatsapp/test', { method: 'POST', body: JSON.stringify(payload) }),
  getWhatsAppSession: () => apiFetch('/api/notifications/whatsapp/session'),
  getWhatsAppGroups: () => apiFetch('/api/notifications/whatsapp/groups'),
  pairWhatsApp: () => apiFetch('/api/notifications/whatsapp/pair', { method: 'POST' }),
  unpairWhatsApp: () => apiFetch('/api/notifications/whatsapp/unpair', { method: 'POST' }),
  clearWhatsAppQueue: () => apiFetch('/api/notifications/whatsapp/clear-queue', { method: 'POST' }),
};
